/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from 'react-bootstrap';
import BaseCom from './BaseCom';

export const Pop = {

    init(showFunction, hideFunction, confirmFunction) {
        this.show = showFunction;
        this.hide = hideFunction;
        this.showConfirm = confirmFunction;
    },

    show(children, title, noFooter) {
        //overriden on init
    },

    showConfirm(children, title, callback, cancelCallback) {
        //overriden on init
    },

    hide() {
        //overriden on init
    }
};

export class PopModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        Pop.init(this.showModal, this.hideModal, this.showConfirm);
    }

    showModal(children, title, noFooter) {
        this.setState({ children: children, title: title, show: true, noFooter: noFooter, onConfirm: null });
    }

    hideModal() {
        this.setState({ children: null, title: null, show: false });
    }

    showConfirm(children, title, callback, cancelCallback) {
        this.setState({ children: children, title: title, show: true, onConfirm: callback, onCancel: cancelCallback });        
    }

    render() {
        return <div className="PopModal">
            <Modal show={this.state.show} onHide={() => { this.setState({ show: false }); if (this.state.onToggle) this.state.onToggle(); }} style={{zIndex: '99999999'}}>
                {this.state.title ? <Modal.Header>
                    {this.state.title}
                </Modal.Header> : ''}
                <Modal.Body>
                    {this.state.children}
                </Modal.Body>
                {!this.state.noFooter ? <Modal.Footer>
                    {!this.state.onConfirm ? <button className="btn btn-secondary btn-lg" onClick={() => { this.setState({ show: false }); if (this.state.onToggle) this.state.onToggle(); }}>Close</button> : ''}
                    {this.state.onConfirm ? <button className="btn btn-secondary" onClick={() => { this.state.onCancel?.(); this.setState({ show: false }); if (this.state.onToggle) this.state.onToggle(); }}>
                        Cancel
                    </button> : ''}
                    {this.state.onConfirm ? <button className="btn btn-primary" onClick={() => { this.state.onConfirm?.(); this.setState({ show: false }); if (this.state.onToggle) this.state.onToggle(); }}>
                        Confirm
                    </button> : ''}
                </Modal.Footer> : ''}
            </Modal>
        </div>;
    }
}